import React, { useState, useEffect } from "react";
const countries = require("../countries");
import TextInput from "./textInput";
import ValidationSummary from "./validationSummary";
const Joi = require("@hapi/joi");
import getConfig from "next/config";
const { publicRuntimeConfig } = getConfig();
const { PADDLE_VENDOR_ID } = publicRuntimeConfig;

const userSchema = Joi.object({
  name: Joi.string().required(),
  email: Joi.string()
    .required()
    .min(3)
    .max(200)
    .regex(/(.+)@(.+){2,}\.(.+){2,}/)
    .message("Must be a valid email address"),
  optIn: Joi.boolean(),
});

let Paddle;

const PaddleCheckout = (ctx) => {
  const {
    brand,
    numPlayers,
    productId,
    meet,
    plan,
    setCountryCode,
    setCurrency,
    countryCode,
    validateGame,
    onPaymentMethodSuccessful,
  } = ctx;
  const [validationErrors, setValidationErrors] = useState([]);
  const [user, setUser] = useState({
    name: "",
    email: "",
    optIn: false,
  });
  useEffect(() => {
    Paddle = window.Paddle;
    Paddle.Setup({ vendor: PADDLE_VENDOR_ID });
  });

  const generateCheckoutLink = async () => {
    const checkoutLinkResponse = await fetch("/api/paddle-checkout-link", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        productId,
        numPlayers,
      }),
    });

    const response = await checkoutLinkResponse.json();
    return response.url;
  };

  const openCheckout = async () => {
    const checkoutArgs = {
      allowQuantity: false,
      country: countryCode,
      product: productId,
      email: user.email,
      passthrough: JSON.stringify({ meet, user }),
      successCallback: async (data, err) => {
        if (!err) {
          onPaymentMethodSuccessful({ meet, user, data, plan, brand });
        } else {
          console.log(err);
        }
      },
    };
    if (plan.name === "custom") {
      checkoutArgs.override = await generateCheckoutLink();
    }
    Paddle.Checkout.open(checkoutArgs);
  };

  async function handleChangeCountry(e) {
    let value = e.target.value;
    const country = countries.find((c) => c.code === value);
    let currency = "GBP";
    if (country) {
      currency = country.currency || "USD";
    }
    setCurrency(currency);
    setCountryCode(value);
  }

  function validateAndRedirect() {
    const gameValidationResult = validateGame();
    if (gameValidationResult) {
      let validationResult = userSchema.validate(user);
      if (validationResult.error) {
        setValidationErrors(validationResult.error.details);
      } else {
        setValidationErrors([]);
        openCheckout();
      }
    }
  }

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === "email") {
      value = value.trim();
    }

    setUser(Object.assign({}, user, { [e.target.name]: value }));
  };

  function handleChangeOptIn() {
    setUser(Object.assign(user, { optIn: !user.optIn }));
  }

  return (
    <div className="paymentForm">
      <h1 className="title">Secure Payment</h1>
      <fieldset className="FormGroup">
        <ValidationSummary validationErrors={validationErrors} />
        <div className="field">
          <label className="label">Country</label>
          <div className="control">
            <div className="select is-fullwidth">
              <select value={countryCode} onChange={handleChangeCountry}>
                {countries.map((c) => {
                  return (
                    <option key={`country-${c.code}`} value={c.code}>
                      {c.name}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
        <div className="field">
          <label htmlFor="name" className="label">
            Name
          </label>
          <div className="control">
            <TextInput
              validationErrors={validationErrors}
              value={user.name}
              onChange={handleChange}
              name="name"
            />
          </div>
        </div>
        <div className="field">
          <label htmlFor="email" className="label">
            Email
          </label>
          <div className="control">
            <TextInput
              validationErrors={validationErrors}
              value={user.email}
              onChange={handleChange}
              name="email"
            />
          </div>
        </div>
      </fieldset>
      <div className="field consent">
        <label className="checkbox">
          <input
            value={user.optIn}
            type="checkbox"
            onChange={handleChangeOptIn}
          />
          I&apos;m happy to be contacted from time to time with offers and
          updates
        </label>
      </div>
      <button
        className="button is-fullwidth  is-large"
        onClick={validateAndRedirect}
      >
        <span>Proceed to payment</span>
      </button>

      <style jsx>{`
        .consent input {
          margin-right: 10px;
        }
        .consent {
          margin: 2em 0;
          text-align: center;
          font-size: 0.8em;
        }
        .paymentForm {
          margin-bottom: 1em;
          max-width: 600px;
          margin: auto;
        }
        .FormGroup {
          padding: 0.5em 0.75em;
          background-color: white;
          will-change: opacity, transform;
          box-shadow: 0 6px 9px rgba(50, 50, 93, 0.06),
            0 2px 5px rgba(0, 0, 0, 0.08), inset 0 1px 0 #829fff;
          border-radius: 4px;
          margin-bottom: 1em;
        }

        .FormRow {
          display: -ms-flexbox;
          display: flex;
          -ms-flex-align: center;
          align-items: center;
          border-top: 1px solid #819efc;
        }
      `}</style>
    </div>
  );
};

export default PaddleCheckout;
